import {defineMessages} from 'react-intl';

export default defineMessages({
  VFS: {
    id: 'RoyalTicketListPanel.VFS',
    defaultMessage: 'View from section {section}',
  },
});
